const searchParameters = {
    guidSearchParameter: "g",
    returnUrlSearchParameter: "ReturnUrl",
    redirect_uri:"redirect_uri",
};
export default searchParameters;